<template>
  <el-container>
    <el-header style="margin-top: 20px;">
      <span>Grabar Acta Liquidación Costo AOM</span>
    </el-header>
    <el-main style="width: 50%; margin-top: 20px;">
      <el-form
        :model="form"
        ref="form-acta-aom"
        label-width="120px"
        :rules="rules"
      >
        <!-- <el-form-item label="CAOM" prop="acao_caom">
          <el-input v-model="form.acao_caom" type="number"></el-input>
        </el-form-item> -->
        <el-form-item label="Fecha Corte" prop="acco_fechacorte">
          <!-- <el-select
            v-model="acco_fechacorte"
            placeholder="Selecciona una fecha"
          >
            <el-option
              v-for="option in mesOptions"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            ></el-option>
          </el-select> -->
          <el-date-picker
            v-model="acco_fechacorte"
            type="month"
            format="yyyy-MM"
            placeholder="Seleccionar mes y año"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="Valor infraestructura expandida" prop="acao_viex">
          <el-input v-model.number="form.acao_viex" type="number"></el-input>
        </el-form-item>

        <el-form-item label="ID Pactado" prop="acao_idpactado">
          <el-input
            v-model="form.acao_idpactado"
            type="number"
            step="0.01"
          ></el-input>
        </el-form-item>

        <el-form-item label="ID Real" prop="acao_idreal">
          <el-input
            v-model="form.acao_idreal"
            type="number"
            step="0.01"
          ></el-input>
        </el-form-item>

        <el-form-item label="IPP" prop="acao_ipp">
          <el-input
            v-model="form.acao_ipp"
            type="number"
            step="0.01"
          ></el-input>
        </el-form-item>

        <el-form-item label="IPPO" prop="acao_ippo">
          <el-input
            v-model="form.acao_ippo"
            type="number"
            step="0.01"
          ></el-input>
        </el-form-item>

        <el-form-item label="VCEEIN" prop="acao_vceein">
          <el-input v-model.number="form.acao_vceein" type="number"></el-input>
        </el-form-item>

        <el-form-item label="Gerente" prop="acao_nombreuno">
          <el-input v-model="form.acao_nombreuno"></el-input>
        </el-form-item>

        <!-- <el-form-item label="Nombre 2" prop="acao_nombredos">
          <el-input v-model="form.acao_nombredos"></el-input>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="submitForm('form-acta-aom')"
            >Grabar</el-button
          >
          <el-button @click="resetForm('form')">Restablecer</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getGrabarActaAom } from '@/api/actas'
  export default {
    data() {
      const currentYear = new Date().getFullYear()
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]
      return {
        form: {
          /* acao_caom: null, */
          acao_viex: null,
          acao_idpactado: null,
          acao_idreal: null,
          acao_ipp: null,
          acao_ippo: null,
          acao_vceein: null,
          acao_nombreuno: null,
          acao_nombredos: null
        },
        acco_fechacorte: new Date(),
        rules: {
          /* acao_caom: [
            {
              required: true,
              message: 'Por favor ingresa un valor para CAOM',
              trigger: 'blur'
            }
          ], */
          acao_viex: [
            {
              required: true,
              message: 'Por favor ingresa un valor para VIEX',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (!Number.isInteger(value)) {
                  callback(new Error('Debe ser un número entero'))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ],
          acao_idpactado: [
            {
              required: true,
              message: 'Por favor ingresa un valor para ID Pactado',
              trigger: 'blur'
            }
          ],
          acao_idreal: [
            {
              required: true,
              message: 'Por favor ingresa un valor para ID Real',
              trigger: 'blur'
            }
          ],
          acao_ipp: [
            {
              required: true,
              message: 'Por favor ingresa un valor para IPP',
              trigger: 'blur'
            }
          ],
          acao_ippo: [
            {
              required: true,
              message: 'Por favor ingresa un valor para IPPO',
              trigger: 'blur'
            }
          ],
          acao_vceein: [
            {
              required: true,
              message: 'Por favor ingresa un valor para VCEEIN',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (!Number.isInteger(value)) {
                  callback(new Error('Debe ser un número entero'))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ],
          acao_nombreuno: [
            {
              required: true,
              message: 'Por favor ingresa un nombre',
              trigger: 'blur'
            }
          ],
          acao_nombredos: [
            {
              required: true,
              message: 'Por favor ingresa un nombre',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            const fecha_periodo = `${this.acco_fechacorte.getFullYear()}-${String(
              this.acco_fechacorte.getMonth() + 1
            ).padStart(2, '0')}-01`
            const formattedData = {
              acao_viex: parseInt(this.form.acao_viex),
              acao_idpactado: parseFloat(this.form.acao_idpactado),
              acao_idreal: parseFloat(this.form.acao_idreal),
              acao_ipp: parseFloat(this.form.acao_ipp),
              acao_ippo: parseFloat(this.form.acao_ippo),
              acao_vceein: parseInt(this.form.acao_vceein),
              acao_nombreuno: this.form.acao_nombreuno,
              acao_nombredos: this.form.acao_nombredos,
              acco_fechacorte: fecha_periodo,
              usua_id: this.usuario.usua_id,
              empr_id: this.empresa.empr_id
            }
            getGrabarActaAom(formattedData)
              .then(response => {
                if (response.data.created) {
                  this.$message({
                    message: 'Acta grabada con éxito',
                    type: 'success'
                  })
                  this.resetForm('form-acta-aom')
                } else {
                  this.$message({
                    message: 'Error al grabar el acta',
                    type: 'error'
                  })
                }
              })
              .catch(err => {
                console.error(err)
                this.$message({
                  message: 'Error al grabar el acta',
                  type: 'error'
                })
              })
            console.log(formattedData)
          } else {
            console.log('error en el formulario')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }
    },
    computed: {
      ...mapGetters(['empresa', 'usuario'])
    }
  }
</script>

<style scoped></style>
